import { Fragment } from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Box, Tooltip } from '@mui/material';

/**
 * Should only render if there's an estimated transit time for the given delivery, which is as of 01/24 only RSE (storefront 5)
 */
const EstimatedDeliveryTooltip = ({ fontSize }: { fontSize?: string }) => {
  return (
    <Fragment>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginLeft: '0.5rem',
        }}
      >
        <Tooltip
          placement="right"
          title={
            'We ship through third party carriers, orders may run into delays.'
          }
        >
          <HelpOutlineIcon sx={fontSize ? { fontSize } : undefined} />
        </Tooltip>
      </Box>
    </Fragment>
  );
};
export default EstimatedDeliveryTooltip;
